import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { ProtectedRoute } from '@/app/providers/ProtectedRoute';
import { AppShell } from '@/app/layout/AppShell';
import { PageSkeleton } from '@/app/components/PageSkeleton';

export function AppLayout() {
  return (
    <ProtectedRoute>
      <AppShell>
        <Suspense fallback={<PageSkeleton />}>
          <Outlet />
        </Suspense>
      </AppShell>
    </ProtectedRoute>
  );
}

export function FullBleedAppLayout() {
  return (
    <ProtectedRoute>
      <AppShell fullBleed>
        <Suspense fallback={<PageSkeleton />}>
          <Outlet />
        </Suspense>
      </AppShell>
    </ProtectedRoute>
  );
}
